import "core-js/modules/es.object.to-string";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import store from '@/store';
export default [{
  name: 'summary',
  path: '/summary',
  beforeEnter: function beforeEnter(to, from, next) {
    var activityId = 1;
    var basicInfo = store.state.activity.basicInfo[activityId];

    if (!basicInfo.joined) {
      _Toast('您还没有报名，暂时无法查看战报');

      next(false);
      return;
    }

    var userId = store.state.user.basicInfo.id;
    next({
      name: ROUTE_NAME.SUMMARY_HUNDRED_10,
      params: {
        userId: userId
      },
      replace: true
    });
  }
}, {
  path: '/report/hundred10/:userId?',
  name: ROUTE_NAME.REPORT_HUNDRED_10,
  meta: {
    title: '完赛证书',
    scrollBehavior: 'top',
    auth: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "summary" */
      '@/pages/summary/report.vue'),
      loading: Loading
    };
  }
}, {
  path: '/report/hundred11/:userId?',
  name: ROUTE_NAME.REPORT_HUNDRED_11,
  meta: {
    title: '完赛证书',
    scrollBehavior: 'top',
    auth: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "summary" */
      '@/pages/summary/report11.vue'),
      loading: Loading
    };
  }
}, {
  path: '/report/hundred12/:userId?',
  name: ROUTE_NAME.REPORT_HUNDRED_12,
  meta: {
    title: '完赛证书',
    scrollBehavior: 'top',
    auth: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "summary" */
      '@/pages/summary/report12.vue'),
      loading: Loading
    };
  }
}, {
  path: '/summary/hundred10/:userId?',
  name: ROUTE_NAME.SUMMARY_HUNDRED_10,
  meta: {
    title: '第10届百日跑战报',
    scrollBehavior: 'top',
    auth: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "summary" */
      '@/pages/summary/hundred10.vue'),
      loading: Loading
    };
  }
}];